module.exports = __webpack_public_path__ + "media/src/images/icons/reward/question-7b35ea43aad20995f3540588c6cbd116.svg";